import React from 'react'
import ReactDOM from 'react-dom';
import {FormControl, Row, Col, Button} from 'react-bootstrap';
//import InputMask from 'react-input-mask'; 
import $ from 'jquery';

//import agent from '../../agent'


import '../../styles/modal.css'; 

import Modal from 'react-bootstrap-modal';
import { connect } from 'react-redux';
import { 
  //BUILDING_LOADED,
  
}from '../../constants/actionTypes'; 
//import menu from '../common/menu.json'
//import { Cookies } from 'react-cookie'
//import { setLocale, getLocale, localizeKey } from 'react-redux-localization';

const mapStateToProps = state => (
    Object.assign({}, state, {
		languageKey: state.common.languageKey
	
    })      
);
const mapDispatchToProps = dispatch => ({
  /*loadCustomers: (data) => {
      dispatch({ type: CUSTOMER_BUILDING_LOADED, payload: data })  
  },
  */
});

class ModalConfirmTimeZone extends React.Component {
	
    constructor() {
        super();
		
        this.state = {			
			isOpen: false,
			
			//lguages:'1005',
			
        }
		
		this.hideModal = ev => {
		  this.setState({
			isOpen: false,
		  });
		 
		 this.props.close();
			
		};
		
		this.handleNo=()=>{
			 this.props.close();
		}
		//---
					
    } 
	
	
	
    componentWillReceiveProps(nextProps) {
		console.log(nextProps)
		
		if(nextProps){
			this.setState({isOpen:nextProps.isOpen,
				
			});
			
		}
		
    }	
	componentWillUpdate(nextProps, nextState){
		
		
		
	}
	componentDidMount() {
		
		
		console.log(this.props.isOpen)
		if(this.props){
			this.setState({isOpen:this.props.isOpen,
				
			});
			
		}
	}
	componentWillMount() {
		
		//const cookies = new Cookies()
		//let language=(cookies.get('language')!='' && cookies.get('language') !=null && cookies.get('language')!== 'undefined')?cookies.get('language'):'1005';
		//this.setState({'lguages':language})
		//console.log(this.props.isOpen)
	}
 
  render() {
	  console.log(this.state.isOpen)
        return (
			<Modal
			  show={this.state.isOpen}
			  onHide={this.hideModal}
			  aria-labelledby="ModalHeader"
			  id="small"
			  className="modal-confirm"
			>
			  <Modal.Header closeButton>
				<Modal.Title id='ModalHeader'>
					<div className="modal-worker-title">
						<span className="modal-detail-order-title"><span style={{'color':'#b81900'}}>message</span></span>
					</div>
				</Modal.Title>
			  </Modal.Header>
			  <Modal.Body>
					<div className="row">		
						<div className="col-md-12 mg5">
							<p >
								The ASSIST System will be undergoing updates that will cause down time for ASSIST users.  The updates will take place between 8 PM PT Friday 10/25 and 12 PM PT on Saturday 10/26. We apologize in advance for any inconveniences this may cause your users. 
							</p>
						</div>
						
						
					</div>
			  </Modal.Body>
			 
			</Modal>
        ); 
	
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(ModalConfirmTimeZone); 